import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { splitArray } from 'utils/arrayHelpers';
import { isDefined } from 'utils/tsHelpers';

import { HasTypename } from './types';

/**
 * Maybe Split Folder Contents
 * Splits a Content type from raw GraphQL response containing 2 or more object types. This will properly handle in progress
 * responses from GraphQL when the response data is undefined
 * @param itemTypename Name of Content type to split out
 * @param contents Array of objects from GraphQL response with __typename property (or undefined)
 * @returns Tuple of Remaining items array and desired Content items array
 */
export const maybeSplitFolderContents = <
  FolderType extends HasTypename,
  ItemType extends HasTypename,
>(
  itemTypename: GRAPHQL_TYPENAMES,
  contents?: (FolderType | ItemType)[],
) =>
  isDefined(contents)
    ? splitArray<FolderType, ItemType>(contents, (item) => item.__typename !== itemTypename)
    : [[], []];
